"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftHeader = void 0;
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_1 = require("@app/util/functional/maybe");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const shift_context_1 = require("../shift-context");
const templateHasValues = (t) => (0, util_1.isValue)(t.id) && (0, util_1.isValue)(t.name);
const bindTemplateWithPosition = (positions) => (template) => ({
    template,
    position: positions?.find((p) => p.id === template.shift?.positionId),
});
const ShiftHeader = () => {
    const { formControl, applyShiftTemplate, selectedTab, disabledEditation, initialData, transferType, transferStatus, } = (0, shift_context_1.useShift)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const positions = (0, store_1.useRootSelector)((state) => state.positions);
    const [shiftTemplateId, setShiftTemplateId] = react_1.default.useState();
    const period = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period.start' });
    // A shift that has already started is attendance, even if it is today's.
    let modalTitle = period.isBefore((0, moment_1.default)())
        ? (0, util_1.t)('ATTENDANCE')
        : (0, util_1.t)('SHIFT');
    if (transferType === 'dsProTransfer') {
        if (initialData?.shiftId) {
            modalTitle = (0, util_1.t)('EDIT_TRANSFER');
        }
        else {
            modalTitle = (0, util_1.t)('ORG_SP_TRANSFERS_DETAILS_ADD');
        }
    }
    const applyShiftTemplateText = (0, util_1.t)('APPLY_SHIFT_TEMPLATE');
    const shiftTemplateOptions = new maybe_1.Maybe(workspace?.shiftTemplates)
        .map((_templates) => _templates.filter(util_1.isValue))
        .map((_templates) => _templates.filter(templateHasValues))
        .map((_templates) => _templates.map(bindTemplateWithPosition(positions)))
        .map((_templates) => _templates.map(({ template, position }) => ({
        value: template.id,
        label: (react_1.default.createElement("span", { style: { display: 'flex', gap: '0.5rem', alignItems: 'center' } },
            react_1.default.createElement("span", null,
                react_1.default.createElement("b", null, template.name)),
            react_1.default.createElement("span", null, `${(0, moment_1.default)(template.shift?.period?.start).format('HH:mm')}
                  -
                  ${(0, moment_1.default)(template.shift?.period?.end).format('HH:mm')}`),
            react_1.default.createElement("span", { className: 'ds-es-tpl-col-pause' }, template.shift?.pausesFixed
                ? // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    (template.shift?.pauses
                        ? template.shift.pauses.reduce((a, s) => {
                            return a + (s?.duration ?? 0);
                        }, 0)
                        : 0) + (0, util_1.t)('MINUTE_SHORT')
                : (0, util_1.t)('SHIFT_TEMPLATE_PAUSES_AUTO')),
            react_1.default.createElement("span", null,
                react_1.default.createElement(ui_1.Position, { sm: true, pos: position ?? {} })),
            react_1.default.createElement("span", null, util_1.calendarUtil.getShiftMetaText(template.shift, workspace)))),
    })))
        .get(() => []);
    return (react_1.default.createElement("div", { style: { display: 'flex', gap: '1rem', alignItems: 'center' } },
        react_1.default.createElement(ui_1.Text, { type: 'body-large', weight: 'bold', nowrap: true }, modalTitle),
        selectedTab === 'overview' &&
            transferStatus !== 'pending' &&
            transferStatus !== 'accepted' && (react_1.default.createElement(ui_1.Dropdown, { searchable: true, singleSelect: true, disabled: (0, util_1.isDefined)(disabledEditation), value: shiftTemplateOptions.find((opt) => opt.value === shiftTemplateId), onChange: (v) => {
                if ((0, util_1.isDefined)(v.value)) {
                    applyShiftTemplate(v.value);
                    setShiftTemplateId(v.value);
                }
            }, disableSort: true, style: 'borderless', size: 'full-width', type: 'variable', options: shiftTemplateOptions, placeholder: applyShiftTemplateText }))));
};
exports.ShiftHeader = ShiftHeader;
